import { GuardError } from '../../../errors/GuardError';
import { showAlert } from '../../../slices/alertSlice';
import { TThunkAction } from '../../../types/redux/thunk';
import { ETelemetryEvents } from '../../../types/telemetry';
import { setFirstMessageUserChatsDisabled } from '../actions';
import { EFirstMessageResponseStatus, IAssertDependencies, TFirstMessageResponse } from '../types';

export const assertUserChatsDisabledStatus =
  (response: TFirstMessageResponse, { domain, telemetry }: IAssertDependencies): TThunkAction<void> =>
  (dispatch, _, { logger }) => {
    if (response.status === EFirstMessageResponseStatus.UserChatsDisabled) {
      telemetry.increment(ETelemetryEvents.ChatFirstMessageSendChatsDisabled);

      dispatch(setFirstMessageUserChatsDisabled());
      dispatch(showAlert({ message: 'Чаты отключены' }));

      const error = new GuardError({
        message: 'Не удалось отправить первое сообщение: у получателя отключены чаты в настройках',
        domain,
        details: { errorCode: response.status },
      });

      logger.error(error);
    }
  };
